"use client";

import { useEffect } from "react";

import { Container } from "@/components/ui/container";
import { Button } from "@/components/ui/button";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <Container className="flex flex-col items-center py-24 text-center">
      <h1 className="text-3xl">Něco se pokazilo</h1>
      <p className="mt-4 max-w-xl text-ink">
        Omlouváme se, při načítání stránky došlo k&nbsp;neočekávané chybě. Zkuste
        to prosím znovu, případně se vraťte na úvodní stránku.
      </p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        <Button onClick={reset}>Zkusit znovu</Button>
        <Button href="/" variant="secondary">
          Zpět na úvod
        </Button>
      </div>
    </Container>
  );
}
